import { z } from "zod"

export const productTextPolicyFindingSchema = z.object({
  policyId: z.string(),
  reason: z.string(),
  simpleSku: z.string(),
  field: z.string(),
  evidence: z.string(),
  status: z.enum(["excluded", "blocked"]),
})
export type ProductTextPolicyFinding = z.infer<typeof productTextPolicyFindingSchema>
